export const APP_CLASSES = [
  "Browser",
  "Hosted",
  "GPU",
  "Windows",
  "macOS",
] as const;
export type AppExecutionClass = (typeof APP_CLASSES)[number];
export const executionDescription: Record<AppExecutionClass, string> = {
  Browser: "Runs directly in your browser.",
  Hosted: "Runs on compute managed by ato.run.",
  GPU: "Uses GPU compute managed by ato.run.",
  Windows: "Runs in a managed Windows environment.",
  macOS: "Runs in a managed macOS environment.",
};
export const managedReason: Record<AppExecutionClass, string> = {
  Browser: "This app runs directly in your browser.",
  Hosted: "This app runs on compute provided by ato.run.",
  GPU: "This app runs on a GPU provided by ato.run.",
  Windows: "This app runs in a Windows environment provided by ato.run.",
  macOS: "This app runs in a macOS environment provided by ato.run.",
};
export function hasAppAccess(kind: AppExecutionClass, paid: boolean) {
  return kind === "Browser" || paid;
}
export function isExecutionClass(value: unknown): value is AppExecutionClass {
  return APP_CLASSES.includes(value as AppExecutionClass);
}
